import React, { useState, useRef, useEffect } from "react";
import { isVerified } from "../../../../../../utils/Helper";
import { useSelector } from "react-redux";
import { Card, Input, Button, Select } from "../../../../../common";
// import { countryCodes } from "../../../profile/countryCodes";
import { ReactComponent as Spinner } from "../../../../../../assets/icons/spinner.svg";
import {
  useCreateKeyPersonnelMutation,
  useCreateKeyPersonnelDraftMutation,
  useCreateCompanyKeyPersonnelMutation,
  useUpdateKeyPersonnelMutation, useUpdateKeyPersonnelDraftMutation
} from "../../../../../../store/Company/companyApiSlice";
import useCompanyUpdate from "../useCompanyFollowUpdate"
import { extractCountryCodeAndPhoneCode } from "../../../../../../utils/countriesState";
import PhoneNumberInput from "../../../../../common/PhoneNumberInput";

export const AddKeyPersonnelForm = ({ editKeyPersonnel, modalHandle, refetch, compRefetch, dataChanged, setDataChanged }) => {
  const nameRef = useRef(null);
  const designationRef = useRef(null);
  const emailRef = useRef(null);
  const mobileRef = useRef(null);
  const [countryCode, setCountryCode] = useState("+971");
  const [countryCodes, setCountryCodes] = useState(extractCountryCodeAndPhoneCode());
  const [mobile, setMobile] = useState("");


  const [nameError, setNameError] = useState("");
  const [designationError, setDesignationError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");


  const { currentEditingCompany } = useSelector((state) => state.company);
  const { token } = useSelector((state) => state.auth);

  const [createKeyPersonnel, { isLoading }] = useCreateKeyPersonnelMutation();
  const [createKeyPersonnelDraft, { isLoading: isCreatingDraft }] = useCreateKeyPersonnelDraftMutation();


  const [updateKeyPersonnel, { isLoading: isUpdating }] =
    useUpdateKeyPersonnelMutation();
  const [createCompanyKeyPersonnel, { isLoading: isCreating }] =
    useCreateCompanyKeyPersonnelMutation();


  const [updateKeyPersonnelDraft, { isLoading: isUpdatingDraft }] =
    useUpdateKeyPersonnelDraftMutation();

  const handleUpdateCompany = useCompanyUpdate();

  useEffect(() => {
    if (editKeyPersonnel) {
      nameRef.current.value = editKeyPersonnel?.name || "";
      designationRef.current.value = editKeyPersonnel?.designation || "";
      emailRef.current.value = editKeyPersonnel?.work_email || "";
      setMobile(editKeyPersonnel?.work_mobile || "");
      setCountryCode(editKeyPersonnel?.work_mobile?.split("|")[0] || "+971");
    }
  }, [editKeyPersonnel]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    if (nameRef.current.value.trim() === "") {
      newErrors.name = "Full Name is required.";
    }

    if (designationRef.current.value.trim() === "") {
      newErrors.designation = "Designation is required.";
    }

    if (emailRef.current.value.trim() === "") {
      newErrors.email = "Email Address is required.";
    } else if (!isValidEmail(emailRef.current.value.trim())) {
      newErrors.email = "Invalid Email Address.";
    }

    if (mobile.trim() === "") {
      newErrors.phone = "Phone Number is required.";
    }
    setNameError(newErrors.name || "");
    setDesignationError(newErrors.designation || "");
    setEmailError(newErrors.email || "");
    setPhoneError(newErrors.phone || "");
    if (Object.keys(newErrors).length > 0) {
      return;
    }


    let work_mobile = mobile;

    const verifiedData = currentEditingCompany.verifiedCompany;

    if (isVerified(verifiedData)) {

      if (editKeyPersonnel) {

        try {
          if (editKeyPersonnel?.key_personnel_draftID) {
            if (editKeyPersonnel?.key_personnelID_id != undefined && editKeyPersonnel?.key_personnelID_id != null) {
              const res = await updateKeyPersonnelDraft({
                key_personnelId: editKeyPersonnel?.key_personnel_draftID,
                data: {
                  key_personnelID: editKeyPersonnel?.key_personnelID_id || editKeyPersonnel?.key_personnelID,
                  current_companyID: currentEditingCompany?.companyID,
                  name: nameRef.current.value,
                  designation: designationRef.current.value,
                  work_email: emailRef.current.value,
                  work_mobile,
                  request_type: 'Key personal update request'
                },
                token,
              });
              if (res) {
                refetch();
                compRefetch();
                setDataChanged(!dataChanged);
                modalHandle();
                // window.location.reload();
              }
            } else {
              const res = await updateKeyPersonnelDraft({
                key_personnelId: editKeyPersonnel?.key_personnel_draftID,
                data: {
                  current_companyID: currentEditingCompany?.companyID,
                  name: nameRef.current.value,
                  designation: designationRef.current.value,
                  work_email: emailRef.current.value,
                  work_mobile,
                  request_type: 'Key personal update request'
                },
                token,
              });
              if (res) {
                refetch();
                compRefetch();
                setDataChanged(!dataChanged);
                modalHandle();
                // window.location.reload();
              }
            }
          } else {
            const res = await createKeyPersonnelDraft({
              data: {
                key_personnelID: editKeyPersonnel?.key_personnelID,
                current_companyID: currentEditingCompany?.companyID,
                name: nameRef.current.value,
                designation: designationRef.current.value,
                work_email: emailRef.current.value,
                work_mobile,
                request_type: 'Key personal create draft request'
              },
              token,
            }).unwrap();
            if (res) {
              refetch();
                compRefetch();
                setDataChanged(!dataChanged);
                modalHandle();
              // window.location.reload();
            }
          }
        } catch (error) {
        } finally {
          modalHandle();
        }
      }
      else {
        try {
          const res = await createKeyPersonnelDraft({
            data: {
              key_personnelID: editKeyPersonnel?.key_personnelID,
              current_companyID: currentEditingCompany?.companyID,
              name: nameRef.current.value,
              designation: designationRef.current.value,
              work_email: emailRef.current.value,
              work_mobile,
              request_type: 'Key personal create draft request'
            },
            token,
          }).unwrap();
          if (res) {
            refetch();
                compRefetch();
                setDataChanged(!dataChanged);
                modalHandle();
            // window.location.reload();
          }
        } catch (error) {
        } finally {
          modalHandle();
        }

      }
    }
    else {

      if (editKeyPersonnel) {
        try {
          const res = await updateKeyPersonnel({
            token,
            key_personnelId: editKeyPersonnel?.key_personnelID,
            data: {
              name: nameRef.current.value,
              designation: designationRef.current.value,
              work_email: emailRef.current.value,
              work_mobile,
            },
          });
          const result = await handleUpdateCompany(currentEditingCompany.companyID, "Key Personnel Updated", token);
          if (!result.success) {
            console.error(result.error);
          }
          if (result) {
            refetch();
                compRefetch();
                setDataChanged(!dataChanged);
                modalHandle();
            // window.location.reload();
          }
        } catch (error) {
        } finally {
          modalHandle();
        }
      } else {
        try {
          const res = await createKeyPersonnel({
            data: {
              current_companyID: currentEditingCompany?.companyID,
              name: nameRef.current.value,
              designation: designationRef.current.value,
              work_email: emailRef.current.value,
              work_mobile,
            },
            token,
          }).unwrap();
          const result = await handleUpdateCompany(currentEditingCompany.companyID, "New Key Personnel Added", token);
          if (!result.success) {
            console.error(result.error);
          }
          if (result) {
            refetch();
                compRefetch();
                setDataChanged(!dataChanged);
                modalHandle();
            // window.location.reload();
          }
        } catch (error) {
        } finally {
          modalHandle();
        }
      }
    }
  };

  return (
    <Card classes="rounded bg-white p-4 w-[34rem]">
      <h5 className="text-f18 text-secondarytwo text-left mb-4">
        Add Key Personnel
      </h5>

      <div className="text-left">
        <Input
          label="Full Name "
          id="name"
          inputRef={nameRef}
          error={nameError}
          placeholder="Enter Full Name"
        />
        <Input
          label="Designation"
          id="designation"
          inputRef={designationRef}
          error={designationError}
          placeholder="Enter Designation"
        />
        <Input
          label="Work Email"
          id="email"
          inputRef={emailRef}
          error={emailError}
          placeholder="Enter Work Email"
        />
        <label className="text-primary text-f14 font-semibold text-left">
          Work Phone
        </label>
        <div className="relative w-full mb-4">
        <PhoneNumberInput
            id="mobile"
            phone={mobile}
            border={true}
            setPhone={setMobile}
            verifyPhoneNumber={false}
            classes={'addBackground'}
            error={phoneError} />
        </div>
        <Button
          onClick={handleSubmit}
          classes="w-full p-2 bg-primary text-white rounded text-f18 mt-4 flex items-center justify-center"
        >
          {isLoading || isUpdating || isCreating || isCreatingDraft || isUpdatingDraft ? <Spinner /> : "Save"}
        </Button>
      </div>
    </Card>
  );
};
const isValidEmail = (email) => {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailPattern.test(email);
};
